import * as types from './constants';

// Get Creator Details
export const getCreatorDetailsPublicRequest = data => (
  { type: types.GET_CREATOR_DETAILS_PUBLIC_REQUEST, payload: data }
);

export const getCreatorDetailsPublicDone = data => (
  { type: types.GET_CREATOR_DETAILS_PUBLIC_DONE, payload: data }
);

export const getCreatorDetailsPublicFailed = errors => (
  { type: types.GET_CREATOR_DETAILS_PUBLIC_FAILED, payload: errors }
);

// Get Creator Details Custom
export const getCreatorDetailsCustomRequest = data => (
  { type: types.GET_CREATOR_DETAILS_CUSTOM_REQUEST, payload: data }
);

export const getCreatorDetailsCustomDone = data => (
  { type: types.GET_CREATOR_DETAILS_CUSTOM_DONE, payload: data }
);

export const getCreatorDetailsCustomFailed = errors => (
  { type: types.GET_CREATOR_DETAILS_CUSTOM_FAILED, payload: errors }
);

// Get Creator Details Sendbird
export const getCreatorDetailsSendbirdRequest = data => (
  { type: types.GET_CREATOR_DETAILS_SENDBIRD_REQUEST, payload: data }
);

export const getCreatorDetailsSendbirdDone = data => (
  { type: types.GET_CREATOR_DETAILS_SENDBIRD_DONE, payload: data }
);

export const getCreatorDetailsSendbirdFailed = errors => (
  { type: types.GET_CREATOR_DETAILS_SENDBIRD_FAILED, payload: errors }
);

export const getCreatorDetailsReset = () => (
  { type: types.GET_CREATOR_DETAILS_RESET }
);
